<div (clickOutside)="closeDropdown($event)" class="page-option-select">
  <button aria-label="Page size"
    class="page-size-btn" (click)="toggleDropdown()">
    {{ selectedOption }}
    <i [ngClass]="{'icon-CaretUp': showDropdown, 'icon-CaretDown': !showDropdown}"></i>
  </button>
  @if (showDropdown) {
    <div class="page-option-dropdown">
      @for (option of pageSizeOptions(); track option) {
        <div class="page-option-item"
             [ngClass]="{selected: option===selectedOption}"
             (click)="optionSelected(option)">{{ option }}
        </div>
      }
    </div>
  }
</div>
